import React from 'react'
import { connect } from 'react-redux'
import DynamicTable from '../../component/DynamicTable'
import classpartActions from '../../action/classpart'
import { localization, secondaryTableOptions, formatTotalElements, getQueryParams } from '../../helper/table'
import { useParams } from 'react-router-dom'


function ClasspartsTable({ dispatch, totalCount }) {
  const params = useParams()

  const fetchPaginatedData = query => dispatch(classpartActions.readPaginated(getQueryParams({ ...query, appId: params.appId })))

  return (
    <DynamicTable
      columns={[
        { title: "Id", field: "id" },
        { title: "Uid", field: "classpart_id" },
        { title: "Titolo", field: "title" },
        { title: "Thumbnail", field: "thumb_filename" },
        { title: "Configurabile", field: "is_configurable", render: rowData => rowData.is_configurable ? 'Si' : 'No' },
        { title: "Istanza-parte default", field: "default_instancepart_title" },
        // { title: "App", field: "app_title" },
        { title: "Abilitato", field: "is_disabled", render: rowData => !rowData.is_disabled ? 'Si' : 'No' },
        { title: "Extra", field: "extra" },
      ]}
      data={fetchPaginatedData}
      title={formatTotalElements(totalCount)}
      options={secondaryTableOptions}
      localization={localization}
    />
  )
}

const mapStateToProps = store => {
  const { classpart } = store
  return {
    totalCount: classpart.totalCount
  }
}


export default connect(mapStateToProps)(ClasspartsTable)